import $ from "cash-dom";
import { gsap } from "gsap";

export default (function () {
    var selector = "[data-caption]";

    function init() {
        if (!$(selector).length) return;

        jdmn.log("function_caption.js initialized", "green");

        var $button = $(selector).find("[data-toggle]");

        $button.off("click");
        $button.on("click", function (_e) {
            var $instance = $(this).parents(selector).eq(0);
            var $body = $instance.find("[data-content]").eq(0);
            var $parent = $body.parent();
            var parentScales = $parent.hasClass("scale-x");

            $button = $(this);
            $button.find("span").toggleClass("on");
            $button.find(".mirror").toggleClass("on");

            if ($body[0].style.height) {
                if ($body[0].scrollHeight >= window.innerHeight && !window.chrome) {
                    // window.scrollBy({ top: -$body[0].scrollHeight, behavior: "smooth" });
                }
                $body.css("height", null).on("transitionend", function () {
                    $(window).trigger("heightChange");
                    if ($body[0].scrollHeight >= window.innerHeight && window.chrome) {
                        // window.scrollBy({ top: -$body[0].scrollHeight, behavior: "smooth" });
                    }
                });
                $button.removeClass("on");
            } else {
                $body.css("height", `${$body[0].scrollHeight}px`).on("transitionend", function () {
                    if (parentScales) $parent.removeClass("scale-x");
                    $(window).trigger("heightChange");
                });
                $button.addClass("on");
            }
        });
    }

    $(document).ready(init);
    $(window).on("contentLoaded", init);
})();
